import type { GaiaPayloadConfigs } from "@expert/shared-types";

/**
 * We are not using app config in the standalone app, so we need to inject a default gaia payload config. Currently we use the asurion config across all partners.
 */
export const defaultGaiaPayloadConfigs: GaiaPayloadConfigs = {
    appName: "expert-assist",
    autoCompleteAppName: "expert-assist-autocomplete",
    areExperimentsEnabled: true,
};
